import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import ExperienceCard from './ExperienceCard';
import volunteerExperience from '../data/volunteerExperience';

function CommunitySection() {
  return (
    <section className="section volunteer-section">
      <div className="container">
        <ScrollEffectWrapper>
          <div className="section-header">
            <h2 className="section-title">Community Involvement</h2>
            <p className="section-subtitle">Giving back through volunteer work</p>
          </div>
        </ScrollEffectWrapper>

        <div className="volunteer-grid">
          {volunteerExperience.map((vol, index) => (
            <ScrollEffectWrapper key={vol.company} delay={index * 200}>
              <ExperienceCard experience={vol} />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CommunitySection;
